var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 18C5.87516 18 5.48294 17.8369 5.15683 17.5108C4.83072 17.1847 4.66739 16.7922 4.66683 16.3333V5.5H3.8335V3.83333H8.00016V3H13.0002V3.83333H17.1668V5.5H16.3335V16.3333C16.3335 16.7917 16.1704 17.1842 15.8443 17.5108C15.5182 17.8375 15.1257 18.0006 14.6668 18H6.3335ZM14.6668 5.5H6.3335V16.3333H14.6668V5.5ZM8.00016 14.6667H9.66683V7.16667H8.00016V14.6667ZM11.3335 14.6667H13.0002V7.16667H11.3335V14.6667Z",
    fill: "#E0252E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.918adcef2c053cb56e376c522cf2a87c.svg";
export { ForwardRef as ReactComponent };